export const getSeasons = state => state.seasons.list;

export const getSeasonById = (state, id) => state.seasons.list.find(season => season.id === id);
export const getSeasonByID = id => state =>
  state.seasons.list.find(season => season.id === Number(id));

export const getSeasonStatusById = (state, id) => state.seasons.status[id];
export const getSeasonStatusByID = id => state => state.seasons.status[id];
